// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor3 from '@/game/prefabs/World/Mentors/Mentor3';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level15 extends TilemapScene {
  constructor() {
    super('Level15');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // desert_biome_5
    const desert_biome_5 = this.add.tilemap('desert-biome-5');
    desert_biome_5.addTilesetImage('desert sands v01', 'desert sands v01');
    desert_biome_5.addTilesetImage(
      'obelisks (shadows) v1',
      'obelisks (shadows) v2',
    );
    desert_biome_5.addTilesetImage(
      'desert sands prefabs',
      'desert sands prefabs',
    );
    desert_biome_5.addTilesetImage('collision', 'collision & alpha');
    desert_biome_5.addTilesetImage(
      'desert trees 80x112',
      'desert trees 80x112',
    );

    // terrain_1
    desert_biome_5.createLayer(
      'terrain',
      ['desert sands v01', 'desert sands prefabs'],
      0,
      0,
    );

    // deco_1
    desert_biome_5.createLayer('deco', ['desert sands v01'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = desert_biome_5.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 48, 304);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 160, 360);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 304, 464);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 368, 224);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 584, 216);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 608, 448);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 784, 424);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 832, 216);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      40,
      432,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      8,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      104,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      200,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      344,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      488,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      584,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      680,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      872,
      528,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      920,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      824,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      680,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      536,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      392,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      248,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      200,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      56,
      592,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      8,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      56,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      152,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      296,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      296,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      344,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      440,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      392,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      248,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      152,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      104,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      488,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      536,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      584,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      632,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      632,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      728,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(
      this,
      776,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(
      this,
      824,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(
      this,
      920,
      528,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(
      this,
      968,
      528,
      'obelisks (shadows) v2',
      2,
    );
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(
      this,
      872,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(
      this,
      776,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(
      this,
      728,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(
      this,
      488,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(
      this,
      440,
      592,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(
      this,
      1016,
      592,
      'obelisks (shadows) v2',
      2,
    );
    this.add.existing(forestTree_42);

    // forestTree_43
    const forestTree_43 = new ForestTree1(
      this,
      1128,
      512,
      'obelisks (shadows) v2',
      2,
    );
    this.add.existing(forestTree_43);

    // forestTree_44
    const forestTree_44 = new ForestTree1(
      this,
      1064,
      336,
      'obelisks (shadows) v2',
      2,
    );
    this.add.existing(forestTree_44);

    // forestTree_45
    const forestTree_45 = new ForestTree1(
      this,
      1048,
      160,
      'obelisks (shadows) v2',
      2,
    );
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(
      this,
      104,
      336,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_46);

    // forestTree_47
    const forestTree_47 = new ForestTree1(
      this,
      424,
      336,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_47);

    // forestTree_48
    const forestTree_48 = new ForestTree1(
      this,
      200,
      432,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_48);

    // forestTree_49
    const forestTree_49 = new ForestTree1(
      this,
      504,
      256,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_49);

    // forestTree_50
    const forestTree_50 = new ForestTree1(
      this,
      584,
      336,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_50);

    // forestTree_51
    const forestTree_51 = new ForestTree1(
      this,
      120,
      432,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_51);

    // forestTree_52
    const forestTree_52 = new ForestTree1(
      this,
      360,
      432,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_52);

    // forestTree_53
    const forestTree_53 = new ForestTree1(
      this,
      264,
      336,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_53);

    // forestTree_54
    const forestTree_54 = new ForestTree1(
      this,
      280,
      256,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_54);

    // forestTree_55
    const forestTree_55 = new ForestTree1(
      this,
      120,
      256,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_55);

    // forestTree_56
    const forestTree_56 = new ForestTree1(
      this,
      680,
      432,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_56);

    // forestTree_57
    const forestTree_57 = new ForestTree1(
      this,
      808,
      336,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_57);

    // forestTree_58
    const forestTree_58 = new ForestTree1(
      this,
      760,
      256,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_58);

    // forestTree_59
    const forestTree_59 = new ForestTree1(
      this,
      120,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_59);

    // forestTree_60
    const forestTree_60 = new ForestTree1(
      this,
      72,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_60);

    // forestTree_61
    const forestTree_61 = new ForestTree1(
      this,
      120,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_61);

    // forestTree_62
    const forestTree_62 = new ForestTree1(
      this,
      216,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_62);

    // forestTree_63
    const forestTree_63 = new ForestTree1(
      this,
      264,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_63);

    // forestTree_64
    const forestTree_64 = new ForestTree1(
      this,
      216,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_64);

    // forestTree_65
    const forestTree_65 = new ForestTree1(
      this,
      360,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_65);

    // forestTree_66
    const forestTree_66 = new ForestTree1(
      this,
      504,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_66);

    // forestTree_67
    const forestTree_67 = new ForestTree1(
      this,
      552,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_67);

    // forestTree_68
    const forestTree_68 = new ForestTree1(
      this,
      696,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_68);

    // forestTree_69
    const forestTree_69 = new ForestTree1(
      this,
      792,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_69);

    // forestTree_70
    const forestTree_70 = new ForestTree1(
      this,
      840,
      112,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_70);

    // forestTree_71
    const forestTree_71 = new ForestTree1(
      this,
      840,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_71);

    // forestTree_72
    const forestTree_72 = new ForestTree1(
      this,
      888,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_72);

    // forestTree_73
    const forestTree_73 = new ForestTree1(
      this,
      792,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_73);

    // forestTree_74
    const forestTree_74 = new ForestTree1(
      this,
      696,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_74);

    // forestTree_75
    const forestTree_75 = new ForestTree1(
      this,
      552,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_75);

    // forestTree_76
    const forestTree_76 = new ForestTree1(
      this,
      456,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_76);

    // forestTree_77
    const forestTree_77 = new ForestTree1(
      this,
      408,
      176,
      'obelisks (shadows) v2',
      1,
    );
    this.add.existing(forestTree_77);

    // forestTree_78
    const forestTree_78 = new ForestTree1(
      this,
      24,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_78);

    // forestTree_79
    const forestTree_79 = new ForestTree1(
      this,
      24,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_79);

    // forestTree_80
    const forestTree_80 = new ForestTree1(
      this,
      72,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_80);

    // forestTree_81
    const forestTree_81 = new ForestTree1(
      this,
      168,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_81);

    // forestTree_82
    const forestTree_82 = new ForestTree1(
      this,
      168,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_82);

    // forestTree_83
    const forestTree_83 = new ForestTree1(
      this,
      264,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_83);

    // forestTree_84
    const forestTree_84 = new ForestTree1(
      this,
      312,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_84);

    // forestTree_85
    const forestTree_85 = new ForestTree1(
      this,
      312,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_85);

    // forestTree_86
    const forestTree_86 = new ForestTree1(
      this,
      360,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_86);

    // forestTree_87
    const forestTree_87 = new ForestTree1(
      this,
      408,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_87);

    // forestTree_88
    const forestTree_88 = new ForestTree1(
      this,
      456,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_88);

    // forestTree_89
    const forestTree_89 = new ForestTree1(
      this,
      504,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_89);

    // forestTree_90
    const forestTree_90 = new ForestTree1(
      this,
      600,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_90);

    // forestTree_91
    const forestTree_91 = new ForestTree1(
      this,
      648,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_91);

    // forestTree_92
    const forestTree_92 = new ForestTree1(
      this,
      600,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_92);

    // forestTree_93
    const forestTree_93 = new ForestTree1(
      this,
      648,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_93);

    // forestTree_94
    const forestTree_94 = new ForestTree1(
      this,
      744,
      176,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_94);

    // forestTree_95
    const forestTree_95 = new ForestTree1(
      this,
      744,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_95);

    // forestTree_96
    const forestTree_96 = new ForestTree1(
      this,
      888,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_96);

    // forestTree_97
    const forestTree_97 = new ForestTree1(
      this,
      936,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_97);

    // forestTree_98
    const forestTree_98 = new ForestTree1(
      this,
      984,
      112,
      'obelisks (shadows) v2',
      3,
    );
    this.add.existing(forestTree_98);

    // forestTree_99
    const forestTree_99 = new ForestTree1(
      this,
      64,
      416,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_99);

    // forestTree_100
    const forestTree_100 = new ForestTree1(
      this,
      288,
      336,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_100);

    // forestTree_101
    const forestTree_101 = new ForestTree1(
      this,
      304,
      48,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_101);

    // forestTree_102
    const forestTree_102 = new ForestTree1(
      this,
      240,
      496,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_102);

    // forestTree_103
    const forestTree_103 = new ForestTree1(
      this,
      128,
      80,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree_103);

    // forestTree_104
    const forestTree_104 = new ForestTree1(
      this,
      448,
      416,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree_104);

    // forestTree_105
    const forestTree_105 = new ForestTree1(
      this,
      160,
      656,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree_105);

    // forestTree_106
    const forestTree_106 = new ForestTree1(this, 216, 400, 'desert 16x_1', 2);
    this.add.existing(forestTree_106);

    // forestTree_107
    const forestTree_107 = new ForestTree1(this, 392, 208, 'desert 16x_1', 2);
    this.add.existing(forestTree_107);

    // forestTree_108
    const forestTree_108 = new ForestTree1(this, 520, 112, 'desert 16x_1', 2);
    this.add.existing(forestTree_108);

    // forestTree_109
    const forestTree_109 = new ForestTree1(this, 184, 48, 'desert 16x', 2);
    this.add.existing(forestTree_109);

    // forestTree_110
    const forestTree_110 = new ForestTree1(this, 376, 32, 'desert 16x', 2);
    this.add.existing(forestTree_110);

    // forestTree_111
    const forestTree_111 = new ForestTree1(this, 440, 128, 'desert 16x', 2);
    this.add.existing(forestTree_111);

    // forestTree_112
    const forestTree_112 = new ForestTree1(this, 184, 192, 'desert 16x', 2);
    this.add.existing(forestTree_112);

    // forestTree_113
    const forestTree_113 = new ForestTree1(this, 120, 608, 'desert 16x', 2);
    this.add.existing(forestTree_113);

    // forestTree_114
    const forestTree_114 = new ForestTree1(this, 552, 544, 'desert 16x', 1);
    this.add.existing(forestTree_114);

    // forestTree_115
    const forestTree_115 = new ForestTree1(this, 392, 544, 'desert 16x', 1);
    this.add.existing(forestTree_115);

    // forestTree_116
    const forestTree_116 = new ForestTree1(this, 264, 624, 'desert 16x', 1);
    this.add.existing(forestTree_116);

    // forestTree_117
    const forestTree_117 = new ForestTree1(this, 264, 592, 'desert 16x', 1);
    this.add.existing(forestTree_117);

    // forestTree_118
    const forestTree_118 = new ForestTree1(this, 312, 496, 'desert 16x', 1);
    this.add.existing(forestTree_118);

    // forestTree_119
    const forestTree_119 = new ForestTree1(this, 264, 512, 'desert 16x', 1);
    this.add.existing(forestTree_119);

    // forestTree_120
    const forestTree_120 = new ForestTree1(this, 424, 48, 'desert 16x', 1);
    this.add.existing(forestTree_120);

    // forestTree_121
    const forestTree_121 = new ForestTree1(this, 424, 16, 'desert 16x', 1);
    this.add.existing(forestTree_121);

    // forestTree_122
    const forestTree_122 = new ForestTree1(this, 232, 32, 'desert 16x', 1);
    this.add.existing(forestTree_122);

    // forestTree_123
    const forestTree_123 = new ForestTree1(this, 24, 272, 'desert 16x_1', 0);
    this.add.existing(forestTree_123);

    // forestTree_124
    const forestTree_124 = new ForestTree1(this, 88, 224, 'desert 16x_1', 0);
    this.add.existing(forestTree_124);

    // forestTree_125
    const forestTree_125 = new ForestTree1(this, 408, 432, 'desert 16x_1', 0);
    this.add.existing(forestTree_125);

    // forestTree_126
    const forestTree_126 = new ForestTree1(this, 72, 448, 'desert 16x_1', 1);
    this.add.existing(forestTree_126);

    // forestTree_127
    const forestTree_127 = new ForestTree1(this, 312, 624, 'desert 16x_1', 1);
    this.add.existing(forestTree_127);

    // mentor
    const mentor = new Mentor3(this, 56, 224);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 800, 256);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 488, 328);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 160, 224);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 936, 296);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 14;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 14;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 14;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 14;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 14;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 14;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 14;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 14;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 14;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 14;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.desert_biome_5 = desert_biome_5;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor3;
  private desert_biome_5!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.desert_biome_5,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
